import { Component, Input, OnInit } from '@angular/core';
import { PartnerService } from '../../../../../services/partner.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TechnicianService } from '../../../../../services/technician.service';
import { TranslateService } from '@ngx-translate/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-technicians-reorder',
  templateUrl: './technicians-reorder.component.html',
  styleUrls: ['./technicians-reorder.component.scss'],
})
export class TechniciansReorderComponent implements OnInit {
  @Input() users;

  public technicians: any = [];
  public loading = false;

  constructor(
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private technicianService: TechnicianService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.filterUsers();
  }

  filterUsers() {
    this.loading = true;
    this.partnerService
      .getPartnerTechnicians(this.helpersService.getPartnerId())
      .subscribe(
        (techList) => {
          //Filter the users for users that have a technicianID and a technician/fitter role --- These APIs really need a rework
          this.technicians = this.users.filter((x) => {
            return (
              x.TechnicianID > 0 &&
              x.UserRoles.filter((y) => {
                return (
                  y.PartnerID === this.helpersService.getPartnerId() &&
                  (y.RoleID === 1 || y.RoleID === 4)
                );
              }).length > 0
            );
          });
          this.technicians.forEach((technician) => {
            var techOrder = techList
              .filter((x) => {
                return x.ID === technician.TechnicianID;
              })
              .pop();
            technician.SortOrder =
              techOrder != null && techOrder.SortOrder >= 0
                ? techOrder.SortOrder
                : 10000;
            technician.Roles = technician.UserRoles.filter((x) => {
              return x.PartnerID === this.helpersService.getPartnerId();
            }).map((x) => {
              switch (x.RoleID) {
                case 1:
                  return this.translate.instant('bikeshop.roles.technician');
                case 2:
                  return this.translate.instant('bikeshop.roles.admin');
                case 3:
                  return this.translate.instant(
                    'bikeshop.roles.workshop_manager',
                  );
                case 4:
                  return this.translate.instant('bikeshop.roles.fitter');
              }
            });
          });
          this.technicians = this.technicians.sort((x, y) => {
            if (x.SortOrder < y.SortOrder) return -1;
            else if (x.SortOrder > y.SortOrder) return 1;
            else return 0;
          });
          console.log(this.technicians);
          console.log(techList);
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  drop(event: CdkDragDrop<string[]>) {
    this.arrayMove(this.technicians, event.previousIndex, event.currentIndex);
    this.partnerService
      .updateTechnicianSortOrder(
        this.helpersService.getPartnerId(),
        this.technicians.map((x, index) => {
          return { TechnicianID: x.TechnicianID, SortOrder: index };
        }),
      )
      .subscribe((res) => {});
  }

  arrayMove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }
}
